import React, { Component } from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import FilingPreview from './FilingPreview';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';

const FORM_NAME = 'PREPARE_FILE';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

class PrepareFile extends Component {

  constructor(props) {
    super(props);
    this.onApproveReport = this.onApproveReport.bind(this);
  }

  render() {
    log.debug('render(): ', this.props);
    let previewComponent = ('');
    if ( !this.props.documentUri && !this.props.multipleFilesToDownload) {
      previewComponent = (<div></div>);
    }
    else {
      previewComponent =  (
        <div>
            <FilingPreview
              documentType={this.props.selectedFilingOption.outputType}
              documentUri={this.props.documentUri || ''}
              documentExtension={this.props.documentExtension || 'txt'}
              formName={this.props.selectedFilingOption.name}
              formXmlId={this.props.selectedFilingOption.formXmlId}
              onApprove={this.onApproveReport}
              filename={this.props.filename}
              filingDocumentFileName={this.props.filingDocumentFileName}
              vatnumber={this.props.vatnumber}
              companyCode={this.props.companyCode}
              companyName={this.props.companyName}
              countryCode={this.props.countryCode}
              periodName={this.props.periodName}
              multipleFilesToDownload={this.props.multipleFilesToDownload}
              fromDate ={this.props.fromDate}
              toDate ={this.props.toDate}
              filingTypeId = {this.props.filingTypeId}
              filingTypeFlow = {this.props.filingTypeFlow}
              onSaveToWorkflow = {this.props.onSaveToWorkflow}
              companyId={this.props.companyId}
              userName={this.props.userName}
              returnDisplayType={this.props.returnDisplayType}
              selectedCorrectionPeriod={this.props.selectedCorrectionPeriod}
            />
        </div>
      );
    }

    return (
      <div>
        <ApplicationMessages messageType="applicationWarning"  messageIds={[ALL_MESSAGES.REPORT_ALREADY_APPROVED] }/>
        { previewComponent }
      </div>
    );
  }

  UNSAFE_componentWillMount(){
    log.debug('componentWillMount()');
  }

  componentWillUnmount() {
    log.debug('componentWillUnmount()');
    //We need to create a logger with the same name as rest client logger
    //to clear errors generated using rest client logger, as logger works 
    //at specified scope level.
    const restClientLog = new Logger('VR-REST-CLIENT', LOG_LEVELS.DEBUG);
    restClientLog.clearDictionaryError(ALL_MESSAGES.REPORT_ALREADY_APPROVED)
  }
  
  onApproveReport() {
    let today = new Date();
    this.submitAnswers({
      approvalDate: today.getFullYear() + "-" + (today.getMonth()+1) + "-" + today.getDate()
    });
  }
  
  submitAnswers(approval) {
    log.debug('onSubmitAnswers(): ', this.props);
    this.props.onSubmit(this.props.name, approval);
  }

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  return {};
}


PrepareFile.defaultProps = {
  selectedFilingOption: {},
  multipleFilesToDownload : false,
  onSubmit: () => {},
    periodName : '',
    fromDate:'',
    toDate:''
};

function mapDispatchersToProps(dispatch) {
  return {};
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(PrepareFile);
